module.exports = __webpack_public_path__ + "img/journal.cb1962eb.webp";